var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "page", attrs: { id: "community_main", role: "main" } },
    [
      _c("community-header"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }